import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_ADJUSTMENT_CODE_STATUS = "GET_ADJUSTMENT_CODE_STATUS";

export const service = async (data) => {
  const options: object = {
    url: `/Api/lookup/GetAdjustmentCodeStatus`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};
const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ADJUSTMENT_CODE_STATUS, service, mock);
